// Chrome fires `beforeinstallprompt` once, seconds after the first page load —
// long before a component mounted by a later route can listen for it. This
// module registers the listener as soon as the bundle is evaluated and keeps
// the event around, so any install button can use it whenever it appears.

let deferredPrompt = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener(deferredPrompt));

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    // Keeps the browser's own mini-infobar away so the in-app button drives it.
    event.preventDefault();
    deferredPrompt = event;
    notify();
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    notify();
  });
}

export const getInstallPrompt = () => deferredPrompt;

export const subscribeInstallPrompt = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// The app is already installed when it is being viewed from its own window.
export const isAppInstalled = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(display-mode: standalone)")?.matches === true ||
    window.navigator?.standalone === true);

// iOS has no install prompt API - Safari users add the app by hand.
export const isIosSafari = () => {
  if (typeof window === "undefined") return false;
  const ua = window.navigator.userAgent || "";
  const isIos = /iPad|iPhone|iPod/.test(ua) || (ua.includes("Mac") && "ontouchend" in document);
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
  return isIos && isSafari;
};

/**
 * Opens the browser install dialog. The saved event is single-use, so it is
 * dropped as soon as it has been shown.
 */
export const showInstallPrompt = async () => {
  if (!deferredPrompt) return { outcome: "unavailable" };

  const event = deferredPrompt;
  deferredPrompt = null;
  notify();

  event.prompt();
  return event.userChoice;
};
